import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {
  gatewayHttpErrorMessage,
  gatewayHttpErrorSeverity,
} from './errors';
import { TransportistaSessionStorage } from '../jwt/session.storage';

export const GATEWAY_ALERT_ID = 'gateway';

@Injectable({ providedIn: 'root' })
export class GatewayHttpLoggingService {
  constructor(private readonly session: TransportistaSessionStorage) {}

  /** Registra fallos HTTP del gateway en consola (sin UI). */
  logHttpError(error: HttpErrorResponse | unknown): void {
    const status =
      error instanceof HttpErrorResponse ? error.status : undefined;
    if (status === 401 && !this.session.getToken()) {
      return;
    }
    const message = gatewayHttpErrorMessage(error);
    const severity = gatewayHttpErrorSeverity(status);

    if (severity === 'error') {
      console.error('[GatewayHTTP]', status, message, error);
    } else {
      console.warn('[GatewayHTTP]', status, message, error);
    }
  }
}
